/** OAuth / magic-link params still in the URL. */
export function hasAuthCallbackInUrl(): boolean {
  const url = new URL(window.location.href);
  const hash = new URLSearchParams(url.hash.replace(/^#/, ''));
  return (
    url.searchParams.has('code') ||
    hash.has('access_token') ||
    url.searchParams.has('error') ||
    hash.has('error') ||
    url.searchParams.has('error_description') ||
    hash.has('error_description')
  );
}

export function getAuthCallbackRedirectUrl(): string {
  return `${window.location.origin}/auth/callback`;
}
